// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"205":"33ac01ad","551":"9c7b26f9","629":"d64c6e73","869":"ea9443e1"}[chunkId] + ".chunk.js";
};